export enum URLS {
  FRONT_CFG = '/api/front/cfg',
  FRONT_API = '/front/api/core',
  CORE_API = '/api/core',
  WS_URL = '/channel',
  MOBILE_CFG = '/api/mobile-cfg/cfg',
  MOBILE_REPORTS = '/api/reports',
}

export const getMobileReportsUrl = (): string => URLS.MOBILE_REPORTS

export const OBJ_CODE_PATH = '/obj_code'
